/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const generateTitleAudioBatchResultSchema = z.object({
  generated: z.number(),
  failed: z.number(),
  remaining: z.number(),
  errors: z.array(z.string()).optional(),
});

export type IGenerateTitleAudioBatchResult = z.infer<typeof generateTitleAudioBatchResultSchema>;

export const generateTitleAudioBatchResponseSchema = createApiResponseSchema(
  generateTitleAudioBatchResultSchema,
) as z.ZodSchema<IAPI<IGenerateTitleAudioBatchResult>>;

export type IGenerateTitleAudioBatchResponse = IAPI<IGenerateTitleAudioBatchResult>;
